import React from 'react';
import ReactDOM from 'react-dom/client';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';
import './deletemsg.css';

export const showDeleteConfirmation = ({ onConfirm, onCancel }) => {
  const container = document.createElement('div');
  document.body.appendChild(container);

  const root = ReactDOM.createRoot(container);

  const handleClose = () => {
    root.unmount();
    document.body.removeChild(container);
  };

  const handleConfirm = () => {
    onConfirm?.();
    handleClose();
  };

  const handleCancel = () => {
    onCancel?.();
    handleClose();
  };

  const ConfirmationDialog = (
    <Dialog open onClose={handleCancel} className="delete-dialog">
      <DialogTitle className="dialog-title">Confirmation</DialogTitle>
      <DialogContent>
        <DialogContentText className="dialog-text">
          Êtes-vous sûr de vouloir supprimer ?
        </DialogContentText>
      </DialogContent>
      <DialogActions className="dialog-actions">
        <Button variant="outlined" color="primary" onClick={handleCancel}>
          Non
        </Button>
        <Button variant="contained" color="error" onClick={handleConfirm}>
          Oui
        </Button>
      </DialogActions>
    </Dialog>
  );

  root.render(ConfirmationDialog);
};
